import { render, staticRenderFns } from "./TestimonialsCard.vue?vue&type=template&id=6c027dfc&scoped=true&"
import script from "./TestimonialsCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialsCard.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialsCard.vue?vue&type=style&index=0&id=6c027dfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c027dfc",
  null
  
)

export default component.exports